import { Slider } from '@mui/material';
import styled from 'styled-components';

export const StyledControlBar = styled.div`
    position: absolute;
    bottom: 10px;
    width: 100%;
    background: rgba(0,0,0,0);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
`;

export const StyledPlayControls = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(0,0,0,0.5);
    box-shadow: 0px -27px 60px rgba(0, 0, 0, 0.51);
    backdrop-filter: blur(8px);
    border-radius: 16px;
    gap: 20px;
    padding: 10px;
    @media (min-width: 768px) {
        gap: 40px;
    }
`;

export const StyledPlayBar = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
`;

export const StyledDetailsIcon = styled.div`
    background: rgba(0, 0, 0, 0.5);
    box-shadow: 4px 6px 9px rgba(0, 0, 0, 0.41);
    backdrop-filter: blur(6.5px);
    border-radius: 10px;
    width: 34px;
    height: 34px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: calc(50% - 130px);
    @media (min-width: 768px) {
        left: calc(50% - 180px);
        width: 34px;
        height: 34px;
    }
    @media (min-width: 1300px) {
        width: 34px;
        height: 34px;
        left: calc(50% - 200px);
    }
    &:hover {
        cursor: pointer;
    }
`;

export const StyledSpeedText = styled.div`
    background: rgba(0, 0, 0, 0.5);
    box-shadow: 4px 6px 9px rgba(0, 0, 0, 0.41);
    backdrop-filter: blur(6.5px);
    border-radius: 4px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    color: #FFF;
    font-size: 12px;
    right: calc(50% - 130px);
    @media (min-width: 768px) {
        right: calc(50% - 180px);
        font-size: 14px;
    }
    @media (min-width: 1300px) {
        right: calc(50% - 200px);
        font-size: 18px;
    }
    &:hover {
        cursor: pointer;
    }
`;

export const FullScreenButton = styled.img`
    background: rgba(0, 0, 0, 0.5);
    box-shadow: 4px 6px 9px rgba(0, 0, 0, 0.41);
    backdrop-filter: blur(6.5px);
    border-radius: 10px;
    width: 34px;
    height: 34px;
    padding: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 5%;
    @media (min-width: 768px) {
        right: 5%;
        width: 34px;
        height: 34px;
    }
    @media (min-width: 1300px) {
        width: 34px;
        height: 34px;
        right: 2.5%;
    }
    &:hover {
        cursor: pointer;
    }
`

export const StyledSliderContainer = styled.div`
    width: 85%;
    color: white;
    display: flex;
    gap: 17px;
    align-items: center;
    margin: 5px 0;
    @media (min-width: 768px) {
        margin: 10px 0;
        width: 90%;
    }
    @media (min-width: 1300px) {
        margin: 15px 0;
        width: 95%;
    }
`;

export const StyledPlayPauseButton = styled.img`
    height: ${props => props?.small ? '30px' : '45px'};
    &:hover {
        cursor: pointer;
    }
    &:active {
        transform: translateY(1px);
    }
`;

export const PrettoSlider = styled(Slider)`
    height: 8px !important;
    & .MuiSlider-track {
      border: 'none';
      height: 10px;
      background-color: #706BCA;
    }
    & .MuiSlider-rail {
        height: 8px;
        background: #9A9A9A;
    }
    & .MuiSlider-thumb {
      height: 18px;
      width: 18px;
      background: #FFFFFF;
    },
    & .MuiSlider-mark {
        width: 5px;
        height: 22px;
        border-radius: 7px;
        margin-top: -6px;
    }
    & .MuiSlider-markLabel{
        padding-top: 5px;
        height: 24px;
        color: white;
    }
`;